import React, { useEffect, useState } from "react";

import ApplyPageClient from "./apply-page-client";
import { shortcodeComponents } from "./application-component";
import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import { PcaHeading } from "../../theme/typography";
import LoadingIcon from "../../loading-icon/loading-icon";
import { PageContainer } from "../../theme/containers";
import { Column } from "../../theme/grid";

const shortcodeRegexp = /\[\/?([A-Za-z-_]+)(?:\s[A-Za-z-_]+="[^"]*")*\](?!\()/g;

const isValidShortcodeComponent = (shortcode: string) =>
    Object.keys(shortcodeComponents).includes(shortcode);

const removeUnknownShortcodes = (content: string) => {
    Array.from(content.matchAll(shortcodeRegexp)).forEach(
        (match: RegExpMatchArray) => {
            if (!isValidShortcodeComponent(match[1])) {
                content = content.replace(match[0], "");
            }
        }
    );
    return content;
};

const convertShortcodes = (content: string) =>
    content.replace(/\[(?!\^)(.*?)\](?!\()/g, (_match, group) => "<" + group + ">");

const processContent = (content: string) => {
    content = removeUnknownShortcodes(content);
    content = convertShortcodes(content);
    return content;
};

const getPageEffect = (
    id: number,
    setLoading: (loading: boolean) => void,
    setTitle: (title: string) => void,
    setContent: (content: string) => void
) => () => {
    const effect = async () => {
        const { post_title, post_content } = await new ApplyPageClient().get(
            id
        );
        setTitle(post_title);
        setContent(processContent(post_content));
        setLoading(false);
    };
    effect();
};

const ApplyPage = ({ id }: { id: number }) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [title, setTitle] = useState<string>("");
    const [content, setContent] = useState<string>("");

    useEffect(getPageEffect(id, setLoading, setTitle, setContent), []);

    return (
        <>
            {loading ? (
                <LoadingIcon />
            ) : (
                <Column
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    backgroundColor="brilliant"
                    display="flex"
                    flexDirection="column"
                    className="applyContent"
                    position="relative"
                    mb={`4rem`}
                >
                    <PageContainer mx={"auto"} pb={"2rem"} maxWidth={848}>
                        <PcaHeading>{title}</PcaHeading>
                        <BoiReactMarkdown
                            components={shortcodeComponents}
                            enableRaw={true}
                            linkTreatment={false}
                        >
                            {content}
                        </BoiReactMarkdown>
                    </PageContainer>
                </Column>
            )}
        </>
    );
};

export default ApplyPage;

export { isValidShortcodeComponent };
